import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-migration/lib";

import { Button } from "@landtechnologies/components";

import { LetterBatchesFilterFormData } from "./LetterBatchesFilterSchema";
import { DateFilter, SearchBatches } from ".";

interface FiltersProps {
  shownCount: number;
  totalCount: number;
}

export const Filters = ({ shownCount, totalCount }: FiltersProps) => {
  const { t } = useTranslation();
  const {
    reset,
    formState: { isDirty },
  } = useFormContext<LetterBatchesFilterFormData>();

  return (
    <div
      className="atlas-flex atlas-w-full atlas-justify-between atlas-items-center atlas-px-5 atlas-py-1"
      data-testid="letter-batches-filters"
    >
      <div className="atlas-flex atlas-items-center atlas-gap-x-3">
        <SearchBatches />
        <DateFilter />
        {isDirty && (
          <Button.Borderless className="atlas-text-content-action" onClick={() => reset()}>
            {t("sites.letter_batches.filters.clear_filters")}
          </Button.Borderless>
        )}
      </div>
      <span className="atlas-flex atlas-font-normal">
        <strong>
          {shownCount} / {totalCount}
        </strong>
        &nbsp;{t("sites.letter_batches.batches")}
      </span>
    </div>
  );
};
